import { render, staticRenderFns } from "./PrescriptionPopup.vue?vue&type=template&id=02191496&"
import script from "./PrescriptionPopup.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports